import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';
import styles from './index.css';

import { Dialog } from '../../../../../components/modal';

class ManOfTheYear extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 插入html
     */

    handleClickRule = () => {
        const { content } = this.props;

        // console.log(content, curArea);

        if (content && content.imgUrl) {
            Dialog.show({
                title: '年度人物',
                content: <img className={styles.judgesImg} src={content.imgUrl} alt="" />,
            });
        } else {
            alert('暂无');
        }
    };

    render() {
        return (
            <div className={styles.other} onClick={this.handleClickRule}>
                年度人物
            </div>
        );
    }
}

const ManOfTheYearChip = props => (
    <Chip id="230126" type="struct" title="美食盛典-年度人物" groupName="正文-美食盛典" content={props.content}>
        <ManOfTheYear />
    </Chip>
);

ManOfTheYearChip.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(ManOfTheYearChip);
